import partner from './engine'
import { runRegistrationShadowPostmate } from './remote'
import { isFromRemote, isFromAffiliate, getRemoteSettings } from '../utils/browserStructure'

function init () {
  if (isFromRemote()) {
    const remoteSettings = getRemoteSettings()

    partner.config = {
      remote: remoteSettings
    }

    partner.start()
    return
  }

  if (isFromAffiliate()) {
    runRegistrationShadowPostmate()
    return
  }

  partner.config = {
    triggers: {
      click: [
        '#signup',
        '[data-regily-trigger="click"]'
      ]
    },
    callbacks: {
      authentication (data) {
        if (typeof window['regilyAuthenticationCallback'] === 'function') {
          return window['regilyAuthenticationCallback'](data)
        }
      },

      identification (data) {
        if (typeof window['regilyIdentificationCallback'] === 'function') {
          return window['regilyIdentificationCallback'](data)
        }
      },

      loginCredentials (data) {
        if (typeof window['regilyLoginCredentialsCallback'] === 'function') {
          return window['regilyLoginCredentialsCallback'](data)
        }
      },

      passwordReset (data) {
        if (typeof window['regilyPasswordResetCallback'] === 'function') {
          return window['regilyPasswordResetCallback'](data)
        }
      },

      update (data, dataDiff) {
        console.info('Updated data', data)
        console.info('Updated data diff', dataDiff)

        if (typeof window['regilyUpdateCallback'] === 'function') {
          return window['regilyUpdateCallback'](data, dataDiff)
        }
      },

      done (data) {
        console.info('Received data', data)

        if (typeof window['regilyCallback'] === 'function') {
          return window['regilyCallback'](data)
        }

        if (typeof window['regilyDoneCallback'] === 'function') {
          return window['regilyDoneCallback'](data)
        }
      },

      event (data) {
        if (typeof window['regilyEventCallback'] === 'function') {
          return window['regilyEventCallback'](data)
        }
      }
    },

    requestCallback (url, data) {
      return fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        },
        body: JSON.stringify(data)
      })
    }
  }

  partner.start()
}

init()



// WEBPACK FOOTER //
// ./src/partners/partner-client-template.js